export interface LocaleDisplayLabels {
  en_US: string;
  it_IT: string;
  nb_NO: string;
}

export class Locale {

  constructor(
    public id: string,
    public displayLabels: LocaleDisplayLabels,
    public localeName: string,
    public nlsLanguage: string,
    public nlsTerritory: string,
    public platformLocalisedInd: string,
    public unitSystemId: string
  ) {
  }

}
